// Dok 42 – Plan för skyddsverksamhet på byggarbetsplatsen (Bas-U).

export interface SafetyActivitySectionDef {
  key: string;
  title: string;
  hint: string;
  template: string;
}

export const SAFETY_ACTIVITY_SECTIONS: SafetyActivitySectionDef[] = [
  {
    key: "organisation",
    title: "Skyddsorganisation",
    hint: "Vem som gör vad i arbetsmiljöarbetet på plats.",
    template:
      "Bas-U: [namn]\nPlatschef: [namn]\nSkyddsombud: [namn och företag]\nHuvudskyddsombud: [namn]\nEntreprenörernas arbetsmiljöansvariga: [lista]",
  },
  {
    key: "moten",
    title: "Möten och dialog",
    hint: "Vilka möten som hålls, hur ofta och vilka som deltar.",
    template:
      "Arbetsmiljö-/samordningsmöte: varannan vecka, Bas-U kallar, samtliga entreprenörer deltar.\nDaglig styrning: varje morgon på plats.\nToolbox talk: veckovis, dokumenteras i Dok 45.\nSkyddskommitté: kvartalsvis om fler än 50 personer arbetar på platsen.",
  },
  {
    key: "ronder",
    title: "Skyddsronder",
    hint: "Frekvens, deltagare och mall.",
    template:
      "Skyddsrond genomförs varannan vecka enligt mallen i Dok 27. Deltagare: Bas-U, skyddsombud och berörd entreprenör. Avvikelser noteras med ansvarig och datum och följs upp vid nästa rond. Överlämnande skyddsrond genomförs vid avslut.",
  },
  {
    key: "introduktion",
    title: "Introduktion och kvittens",
    hint: "Hur nya på arbetsplatsen tas emot.",
    template:
      "Alla som ska arbeta på arbetsplatsen får introduktion innan arbetet påbörjas: arbetsmiljöplan, ordningsregler, larmrutin, utrymning och aktuella risker. Introduktionen kvitteras och registreras i Dok 14.",
  },
  {
    key: "beredskap",
    title: "Beredskap, larm och första hjälpen",
    hint: "Larmrutin, utrustning och utbildade personer.",
    template:
      "Larmnummer 112. Adress och uppsamlingsplats anslås vid etableringen.\nFörsta hjälpen-utrustning: [placering]\nHjärtstartare: [placering]\nUtbildade i första hjälpen och HLR: [namn]\nUtrymningsövning genomförs vid etablering och vid större förändringar.",
  },
  {
    key: "kommunikation",
    title: "Kommunikation och språk",
    hint: "Hur information når alla på plats.",
    template:
      "Information ges på svenska och engelska. Vid arbetslag med annat språk säkerställs tolk eller översatt material. Ordningsregler och skyltning används med symboler där det är möjligt.",
  },
  {
    key: "uppfoljning",
    title: "Uppföljning och mätetal",
    hint: "Vad som följs upp och hur ofta.",
    template:
      "Följs upp månadsvis: antal skyddsronder, antal öppna avvikelser, tillbud och olyckor, kvittenser av AMP samt genomförda toolbox talks. Resultatet redovisas för byggherren.",
  },
];

export const SAFETY_ACTIVITY_STATUS_LABELS: Record<string, string> = {
  utkast: "Utkast",
  granskning: "Under granskning",
  faststalld: "Fastställd",
};
